export default __webpack_public_path__ + "static/media/dashboard.2f3c6e68.svg";